import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

const useGetBasicBookingInfo = (orgSlug: string, tourSlug: string) => {
  return useQuery(getBasicBookingInfoQueryOptions(orgSlug, tourSlug));
};

export const getBasicBookingInfoQueryOptions = (
  orgSlug: string,
  tourSlug: string,
): UseQueryOptions<BookingTourBasicDataDto> => ({
  queryKey: bookingApiQueryKeys.basicInfo(orgSlug, tourSlug),
  queryFn: () => bookingApi.getBasicTourInfo(orgSlug, tourSlug),
  staleTime: 1000 * 60,
  gcTime: 1000 * 60 * 5,
  retry: 1,
});

export default useGetBasicBookingInfo;
